/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModifyBookOnlineConfigurationDataCmd } from '../../models/modify-book-online-configuration-data-cmd';
import { ValidationError } from '../../models/validation-error';

export interface UpdateOnlineConfigData$Params {

/**
 * id configuration type book
 */
  id: string;
      body?: ModifyBookOnlineConfigurationDataCmd
}

export function updateOnlineConfigData(http: HttpClient, rootUrl: string, params: UpdateOnlineConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
  const rb = new RequestBuilder(rootUrl, updateOnlineConfigData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationError>>;
    })
  );
}

updateOnlineConfigData.PATH = '/api/configuration/{id}/book/online';
